var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1947_64963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.75006C4.45098 3.06296 5.39343 2.6781 6.375 2.6781C7.35657 2.6781 8.29902 3.06296 9 3.75006C9.70098 4.43717 10.6434 4.82203 11.625 4.82203C12.6066 4.82203 13.549 4.43717 14.25 3.75006V10.5001C13.549 11.1872 12.6066 11.572 11.625 11.572C10.6434 11.572 9.70098 11.1872 9 10.5001C8.29902 9.81296 7.35657 9.4281 6.375 9.4281C5.39343 9.4281 4.45098 9.81296 3.75 10.5001V3.75006Z",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 15.75V10.5",
    stroke: "#616E85",
    strokeWidth: 1.3125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1947_64963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlags);
export default __webpack_public_path__ + "static/media/Flags.9786b8b1b91f1977559a1e438db16fe4.svg";
export { ForwardRef as ReactComponent };